import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
} from "reactstrap";
import Overview from "./Detail/Overview/Index";
import UtilitiesList from "./Detail/Utilities";
import inquiryListApi from "api/inquiryListApi";

const InquiryListDetail = ({
  inquiryID,
  setLinkImage,
  setTitleInquiryDetail,
  dataInquiryTypes
}: any) => {
  const [detail, setDetail] = useState<any>();
  
  const getDetail = async () => {
    try {
      const response: any = await inquiryListApi?.getInquiryDetail(inquiryID);
      if (response.code == 200) setDetail(response?.data);
    }catch {
      console.log("log data")
    }
  }

  useEffect(() => {
    getDetail();
  }, []);

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Overview
            inquiryId={inquiryID}
            data={detail}
            setLinkImage={setLinkImage}
            setTitleInquiryDetail={setTitleInquiryDetail}
            reloadData={getDetail}
            dataInquiryTypes={dataInquiryTypes}
          />

          <UtilitiesList
            inquiryID={inquiryID}
            detail={detail}
            data={detail?.inquiryReplies || []}
            reloadData={getDetail}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default InquiryListDetail;
